import { AnswerStatementRequest, PostStatementRequest, PutStatementRequest } from '../types/formdataTypes';
import {
	AuditResponse,
	PutStatementDeadlineRequest,
	PutStatementStateRequest,
	StatementEmailReminderRequest,
	StatementResponse,
} from '../types/types';
import { HttpResponse, makeRequest } from './index';
const endpoint = 'Statement';

export const answerStatement = async (request: AnswerStatementRequest): Promise<HttpResponse<string>> => {
	const formData = new FormData();
	formData.append('statementId', request.statementId);
	formData.append('emailToken', request.emailToken);
	formData.append('answer', request.answer);

	if (request.files) {
		request.files.forEach((file, index) => {
			formData.append(`files[${index}]`, file.bytes, file.fileName);
		});
	}

	if (request.links) {
		formData.append('links', JSON.stringify(request.links));
	}

	const result = await makeRequest<any, string>(`${endpoint}/answer`, formData, 'post', true);
	return result;
};

export const putStatement = async (request: PutStatementRequest): Promise<HttpResponse<string>> => {
	const formData = new FormData();
	formData.append('statementId', request.statementId);
	formData.append('title', request.title);

	if (request.answer) {
		formData.append('answer', request.answer);
	}

	if (request.files) {
		request.files.forEach((file, index) => {
			formData.append(`files[${index}]`, file.bytes, file.fileName);
		});
	}

	if (request.links) {
		formData.append('links', JSON.stringify(request.links));
	}

	if (request.internalNote) {
		formData.append('internalNote', request.internalNote);
	}

	const result = await makeRequest<any, string>(`${endpoint}`, formData, 'put', true);
	return result;
};

export const putStatementDeadline = async (request: PutStatementDeadlineRequest): Promise<HttpResponse<string>> => {
	const result = await makeRequest<PutStatementDeadlineRequest, string>(`${endpoint}/deadline`, request, 'put');
	return result;
};

export const putStatementState = async (request: PutStatementStateRequest): Promise<HttpResponse<string>> => {
	const result = await makeRequest<PutStatementStateRequest, string>(`${endpoint}/state`, request, 'put');
	return result;
};

export const getStatement = async (id: string, token?: string): Promise<HttpResponse<StatementResponse>> => {
	const tokenString = token ? `&token=${token}` : '';
	const result = await makeRequest<string, StatementResponse>(`${endpoint}?statementId=${id}${tokenString}`, null, 'get');
	return result;
};

export const sendStatementReminder = async (request: StatementEmailReminderRequest): Promise<HttpResponse<string>> => {
	const result = await makeRequest<StatementEmailReminderRequest, string>(`${endpoint}/reminder`, request, 'post');
	return result;
};

export const postStatement = async (request: PostStatementRequest): Promise<HttpResponse<StatementResponse>> => {
	const formData = new FormData();
	formData.append('userId', request.userId);
	formData.append('caseId', request.caseId);
	formData.append('title', request.title);
	formData.append('answer', request.answer);
	formData.append('answeredDate', request.answeredDate);
	formData.append('createdDate', request.createdDate);

	if (request.files) {
		request.files.forEach((file, index) => {
			formData.append(`files[${index}]`, file.bytes, file.fileName);
		});
	}

	if (request.links) {
		formData.append('links', JSON.stringify(request.links));
	}

	if (request.internalNote) {
		formData.append('internalNote', request.internalNote);
	}
	const result = await makeRequest<any, StatementResponse>(`${endpoint}`, formData, 'post', true);
	return result;
};

export const getStatementLogs = async (id: string): Promise<HttpResponse<AuditResponse[]>> => {
	const result = await makeRequest<string, AuditResponse[]>(`${endpoint}/logs?statementId=${id}`, null, 'get');
	return result;
};

export const deleteStatement = async (id: string): Promise<HttpResponse<string>> => {
	const result = await makeRequest<string, string>(`${endpoint}?statementId=${id}`, null, 'delete');
	return result;
};
